import { render, staticRenderFns } from "./CompanyDetailsTable.vue?vue&type=template&id=8435b118&scoped=true"
import script from "./CompanyDetailsTable.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailsTable.vue?vue&type=style&index=0&id=8435b118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8435b118",
  null
  
)

export default component.exports